<template>
  <div id="splash-portrait">
    <Navbar />
    <div class="rotating-screen"/>
    <h2>Please turn <br/> your device</h2>
    <span class="desktop-msg">This website is best viewed on desktop</span>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "./Navbar.vue"
export default {
  name: 'splash-portrait',
  components: {
    Navbar
  },
  computed:{
  },
  data() {
    return {
    }
  },
  mounted: function(){
  }
}
</script>
<style lang="scss">
#splash-portrait{
  width:100vw;
  height:100vh;
  z-index:9;
  position:fixed;
  left:0px;
  top:0px;
  background:black;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content:center;
  background: url(../assets/imgs/splash-mobile-portrait.jpg);
  background-size: cover;
  visibility: hidden;
  >a{
    position: absolute;
    right: 1.63rem;
    bottom: 1.63rem;
  }
}
.rotating-screen{
  width: 22vw;

  height: 39vw;
  background: url(../assets/icons/phone.svg);
  background-repeat: no-repeat;
  -webkit-animation-name:            rotate;
  -webkit-animation-duration:        2.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
}

@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    opacity:0.0;
  }
  20% {
    -webkit-transform: rotate(0deg);
    opacity:0.0;
  }
  30% {
    -webkit-transform: rotate(0deg);
    opacity:1;
  }
  80% {
    -webkit-transform: rotate(90deg);
    opacity:1;
  }
  100% {
    -webkit-transform: rotate(90deg);
    opacity:0;
  }
}

#splash-portrait h2{
  margin-top:3rem;
  font-size:2rem;
}
</style>
